import { render, staticRenderFns } from "./UpgradeIframe.vue?vue&type=template&id=bc6b4fa4&"
import script from "./UpgradeIframe.vue?vue&type=script&lang=js&"
export * from "./UpgradeIframe.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeIframe.vue?vue&type=style&index=0&id=bc6b4fa4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QIcon})
